exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".model {\n  position: fixed;\n  width: 100%;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background: rgba(0, 0, 0, 0.2);\n  z-index: 999;\n}\n.model .model-content {\n  width: 100%;\n  position: absolute;\n  z-index: 999;\n  top: 25%;\n  padding: 15px 15px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.model .model-content .model-img {\n  width: 100%;\n  height: 100%;\n}\n.model-none {\n  display: none;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/less-loader/dist/cjs.js?{"javascriptEnabled":true}!./src/component/model/index.less
// module id = 81
// module chunks = 0